/**
 * Created by glopez on 22/05/17.
 */
import {ActionTypes, Status} from 'store/actions/modules/miniepg';

const initialState = {
    status: Status.COLLAPSED
};

/**
 * Returns component status.
 *
 * @param {string} state - Current state.
 * @param {Object} action - Status to get.
 * @returns {string} State.
 */
function status (state = Status.COLLAPSED, action) {
    switch (action.type) {
        case ActionTypes.SET_MINIEPG_STATUS:
            return action.status;

        default:
            return state;
    }
}

/**
 * Returns the input's shown state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
function miniepg (state = initialState, action) {
    return {
        status: status(state.status, action)
    };
}

export default miniepg;


// WEBPACK FOOTER //
// ./src/js/store/reducers/modules/miniepg.js